"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateText = exports.serializeText = void 0;
const serializeText = (item) => {
    return typeof item.data.text === "string" ? item.data.text : "";
};
exports.serializeText = serializeText;
const validateText = (item) => {
    if (!item.required || item.data.text) {
        return { valid: true };
    }
    return { valid: false, error: { message: "Must be filled out." } };
};
exports.validateText = validateText;
//# sourceMappingURL=text.js.map